// export const IMG_PATH = 'http://localhost:8888/static/';
// export const IMG_PATH = 'http://174.138.16.12:8888/static/';
export const IMG_PATH = 'https://api.misumiprivilege.com/static/';

// export const IMG_PATH= 'https://api.mobileconnectsolution.com/static/';
